import { render, staticRenderFns } from "./BaseActionModal.vue?vue&type=template&id=21c01952&scoped=true&"
import script from "./BaseActionModal.vue?vue&type=script&lang=js&"
export * from "./BaseActionModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseActionModal.vue?vue&type=style&index=0&id=21c01952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c01952",
  null
  
)

export default component.exports